import { StationServiceClient } from '../../grpc/StationServiceClientPb';
import { AllStationsRequest, FilteredStationRequest, StationResponse, StationRequest, Station } from '../../grpc/station_pb';
import { GRPC_STATION_PORT } from '../../constants';
import Auth from '../../auth/abstract-auth';
import { CONSOLE_ERROR_MSG, requestMetadata } from '../util';
import { Station as WebStation, toGRPCStation } from "../../@types/grpc/station";

export default class StationServiceConsumer {
  private stationServiceClient: StationServiceClient;
  private auth: Auth;
  private oriApiKey: undefined | string;

  constructor(auth: Auth, hostname: string, oriApiKey?: undefined | string) {
    this.auth = auth;
    this.oriApiKey = oriApiKey;
    this.stationServiceClient = new StationServiceClient(`${hostname}:${GRPC_STATION_PORT}`, null, null);
  }

  public getStations = (id: number, cursor?: number): Promise<StationResponse> => {
    const request = new FilteredStationRequest();
    request.setId(id);
    if (cursor) {
      request.setCursor(cursor);
    }
    return new Promise(async (resolve, reject) => {
      this.stationServiceClient.getStations(request, await requestMetadata(this.auth, this.oriApiKey), (err, response) => {
        if (!err) {
          const stations = response.getStationResponse();
          if (response.hasError()) {
            reject(response.getError());
          } else if (response.hasStationResponse() && stations) {
            resolve(stations);
          } else {
            throw new Error(CONSOLE_ERROR_MSG);
          }
        } else {
          reject(err);
        }
      });
    });
  }

  public getDestinationsFromStation = (id: number): Promise<StationResponse> => {
    const request = new StationRequest();
    request.setId(id);
    return new Promise(async (resolve, reject) => {
      this.stationServiceClient.getDestinationsFromStation(request, await requestMetadata(this.auth, this.oriApiKey), (err, response) => {
        if (!err) {
          const stations = response.getStationResponse();
          if (response.hasError()) {
            reject(response.getError());
          } else if (response.hasStationResponse() && stations) {
            resolve(stations);
          } else {
            throw new Error(CONSOLE_ERROR_MSG);
          }
        } else {
          reject(err);
        }
      });
    });
  }

  public getOriginsFromStation = (id: number): Promise<StationResponse> => {
    const request = new StationRequest();
    request.setId(id);
    return new Promise(async (resolve, reject) => {
      this.stationServiceClient.getOriginsFromStation(request, await requestMetadata(this.auth, this.oriApiKey), (err, response) => {
        if (!err) {
          const stations = response.getStationResponse();
          if (response.hasError()) {
            reject(response.getError());
          } else if (response.hasStationResponse() && stations) {
            resolve(stations);
          } else {
            throw new Error(CONSOLE_ERROR_MSG);
          }
        } else {
          reject(err);
        }
      });
    });
  }

  public getAllStations = (operatingAreas: number[]): Promise<StationResponse> => {
    const request = new AllStationsRequest();
    request.setOperatingAreaIdsList(operatingAreas);
    return new Promise(async (resolve, reject) => {
      this.stationServiceClient.getAllStations(request, await requestMetadata(this.auth, this.oriApiKey), (err, response) => {
        if (!err) {
          const stations = response.getStationResponse();
          if (response.hasError()) {
            reject(response.getError());
          } else if (response.hasStationResponse() && stations) {
            resolve(stations);
          } else {
            throw new Error(CONSOLE_ERROR_MSG);
          }
        } else {
          reject(err);
        }
      });
    });
  }

  public addStation = (station: WebStation, operatingAreaID : number, disabledDate?: string): Promise<Station> => {
    const request = toGRPCStation(station);
    request.setOperatingAreaId(operatingAreaID);

    request.setDisabledDate(disabledDate || "");

    return new Promise(async (resolve, reject) => {
      this.stationServiceClient.createStation(
        request,
        await requestMetadata(this.auth, this.oriApiKey),
        (err, response) => {
          if (!err) {
            resolve(response);
          } else {
            reject(err);
          }
        }
      );
    })
  }

  public updateStation = (station: WebStation, operatingAreaID : number, disabledDate?: string): Promise<Station> => {
    const request = toGRPCStation(station);
    request.setOperatingAreaId(operatingAreaID);

    request.setDisabledDate(disabledDate || "");

    return new Promise(async (resolve, reject) => {
      this.stationServiceClient.updateStation(
        request,
        await requestMetadata(this.auth, this.oriApiKey),
        (err, response) => {
          if (!err) {
            resolve(response);
          } else {
            reject(err);
          }
        }
      );
    })
  }
}
